module.exports = __webpack_public_path__ + "static/media/4levelLow.5e381474.jpg";